import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { VwSecDependencia } from '../../../../shared/interfaces/database/seguridad';
import { SecDependenciaService } from '../../../../services/database/secDependencia.service';
import { MessageService } from 'primeng/api';
import { AccessRole, ButtonColumnType, CustomTableComponent, DataColumnType, ICustomTable, LocalService, Page } from 'lib-base';
import { AdminTipoTramiteDependenciaComponent } from './admin-tipo-tramite-dependencia/admin-tipo-tramite-dependencia.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';

@Component({
  selector: 'app-admin-dependencia-tramite',
  standalone: true,
  imports: [
    CommonModule, TranslateModule, CustomTableComponent,
    TableModule, ButtonModule,
    AdminTipoTramiteDependenciaComponent,
  ],
  templateUrl: './admin-dependencia-tramite.component.html',
  styleUrls: ['./admin-dependencia-tramite.component.scss']
})
export class AdminDependenciaTramiteComponent implements OnInit {

  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  role = AccessRole;
  private originalValues: any;

  constructor(private _sd: SecDependenciaService, private _ms: MessageService, private _t: TranslateService, public ls: LocalService) {
  }

  ngOnInit(): void {
    this.translate();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      title: this._t.get('components.app-admin-tramites.app-admin-dependencia-tramite.title'),
      dependencia: this._t.get('common.dependencia'),
    }));

    this.customTable = {
      columns: [
        {
          field: 'expand',
          header: '',
          class: 'p-button-info',
          width: '0.5rem',
          buttonType: ButtonColumnType.EXPANDED
        },
        {
          field: 'descripcion',
          header: this.trans.dependencia,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        }
      ],
      settings: {
        table: {
          rows: 5,
        }
      }
    } as ICustomTable;
  }

  getDependencias() {
    this._sd.getDependencias().subscribe({
      next: (page: Page<VwSecDependencia>) => {
        this.customTableComponent.data = page.content;
      }
    });
  }
}
